var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullScreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20 14.546V20h-5.454l2.094-2.094L14 15.309 15.31 14l2.595 2.64zM9.455 20H4v-5.454l2.095 2.094L8.69 14 10 15.31l-2.64 2.595zM4 9.455V4h5.455L7.36 6.095 10 8.69 8.69 10 6.096 7.36zM14.546 4H20v5.455L17.906 7.36 15.309 10 14 8.69l2.64-2.595z",
  clipRule: "evenodd"
})));
export default SvgFullScreen;